import { create } from "zustand"

export enum SelectedClientStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
}

interface ClientTableFilterStore {
  selectedClientStatus: SelectedClientStatus
  setSelectedClientStatus: (filter: SelectedClientStatus) => void
}

const useClientTableFilterStore = create<ClientTableFilterStore>((set) => ({
  selectedClientStatus: SelectedClientStatus.ACTIVE,
  setSelectedClientStatus: (filter: SelectedClientStatus) =>
    set({ selectedClientStatus: filter }),
}))

export default useClientTableFilterStore
